import { useQuery } from '@tanstack/react-query';
import { experimentsApi } from '../api/experiments';

export const useExperiments = (status?: string) => {
  return useQuery({
    queryKey: ['experiments', status],
    queryFn: () => experimentsApi.list(status),
    staleTime: 30000,
  });
};

export const useExperiment = (id: string) => {
  return useQuery({
    queryKey: ['experiments', id],
    queryFn: () => experimentsApi.get(id),
    enabled: !!id,
  });
};

export const useExperimentStats = () => {
  return useQuery({
    queryKey: ['experiments', 'stats'],
    queryFn: async () => {
      const all = await experimentsApi.list();
      return {
        total: all.length,
        active: all.filter((e) => e.status === 'ACTIVE').length,
        draft: all.filter((e) => e.status === 'DRAFT').length,
        paused: all.filter((e) => e.status === 'PAUSED').length,
        archived: all.filter((e) => e.status === 'ARCHIVED').length,
      };
    },
    staleTime: 60000,
  });
};
